/* eslint-disable camelcase */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TeamLineupsContext } from 'widgets/mc-team-lineups/js/components/MCTeamLineups';
import { TAMilestoneList } from './TAMilestoneList';

/**
 * Renders the milestones data.
 *
 * @param {object} props - The props
 * @param {Array} props.homeMilestones - The home milestones data.
 * @param {Array} props.awayMilestones - The away milestones data.
 * @param {string} props.teamDisplay - Which team to display (both, home or away).
 * @param {boolean} props.isAFLW - Whether this is an AFLW match.
 * @param {string} props.homeTeamId - The home team's ID.
 * @param {string} props.awayTeamId - The away team's ID.
 * @returns {React.JSX.Element} - The rendered component
 */
export const TeamAnnouncementsFieldMilestones = ({
    homeMilestones,
    awayMilestones,
    teamDisplay,
    isAFLW,
    homeTeamId,
    awayTeamId
}) => {
    const teamLineupsContext = useContext(TeamLineupsContext);
    const trackingContentTypes =
        PULSE.app.common.CONSTANTS.TRACKING.CONTENT_TYPES;

    const trackingContentType =
        teamLineupsContext === 'match-centre'
            ? trackingContentTypes.MATCH_CENTRE.LINEUPS
            : trackingContentTypes.LINEUPS;

    const isSingleTeam = teamDisplay === 'home' || teamDisplay === 'away';
    const singleTeamMilestones =
        teamDisplay === 'home' ? homeMilestones : awayMilestones;
    const singleTeamClubId = teamDisplay === 'home' ? homeTeamId : awayTeamId;

    return (
        <div className="team-announcements-field__footer-section team-announcements-field__footer-section--milestones">
            {isSingleTeam && (
                <>
                    <span className="team-announcements-field__footer-section-label">
                        Milestones
                    </span>
                    <span className="team-announcements-field__footer-section-values">
                        <TAMilestoneList
                            milestones={singleTeamMilestones}
                            isAFLW={isAFLW}
                            clubId={singleTeamClubId}
                            trackingContentType={trackingContentType}
                        />
                    </span>
                </>
            )}

            {teamDisplay === 'both' && (
                <>
                    <span className="team-announcements-field__footer-section-values team-announcements-field__footer-section-values--home">
                        <TAMilestoneList
                            milestones={homeMilestones}
                            isAFLW={isAFLW}
                            clubId={homeTeamId}
                            trackingContentType={trackingContentType}
                        />
                    </span>

                    <span className="team-announcements-field__footer-section-label">
                        Milestones
                    </span>

                    <span className="team-announcements-field__footer-section-values team-announcements-field__footer-section-values--away">
                        <TAMilestoneList
                            milestones={awayMilestones}
                            isAFLW={isAFLW}
                            clubId={awayTeamId}
                            trackingContentType={trackingContentType}
                        />
                    </span>
                </>
            )}
        </div>
    );
};

TeamAnnouncementsFieldMilestones.propTypes = {
    homeMilestones: PropTypes.array,
    awayMilestones: PropTypes.array,
    teamDisplay: PropTypes.oneOf(['both', 'home', 'away']),
    isAFLW: PropTypes.bool,
    homeTeamId: PropTypes.string,
    awayTeamId: PropTypes.string
};
